import { TextField } from "@mui/material";
import React from "react";

const Input = React.forwardRef(({ error, variant = "outlined", margin = "dense",value, onChange, ...props }, ref) => {

    return (
        <TextField
            {...props}
            error={error && true}
            onChange={onChange} // Pass the onChange event handler
            inputRef={ref}
            margin={margin}
            variant={variant}
            value={value}
            fullWidth
            autoComplete="off"
            helperText={error?.message}
            InputLabelProps={{ shrink: true }}
        />
    )

});

export default Input;
